import _extends from '../../../node_modules/.pnpm/@babel_runtime@7.24.0/node_modules/@babel/runtime/helpers/esm/extends.js';
import '../../../node_modules/.pnpm/core-js@3.36.1/node_modules/core-js/modules/es.symbol.constructor.js';
import '../../../node_modules/.pnpm/core-js@3.36.1/node_modules/core-js/modules/es.symbol.for.js';
import '../../../node_modules/.pnpm/core-js@3.36.1/node_modules/core-js/modules/es.symbol.key-for.js';
import '../../../node_modules/.pnpm/core-js@3.36.1/node_modules/core-js/modules/es.json.stringify.js';
import '../../../node_modules/.pnpm/core-js@3.36.1/node_modules/core-js/modules/es.object.get-own-property-symbols.js';
import '../../../node_modules/.pnpm/core-js@3.36.1/node_modules/core-js/modules/es.symbol.description.js';
import '../../../node_modules/.pnpm/core-js@3.36.1/node_modules/core-js/modules/es.function.name.js';
import React, { useMemo } from 'react';
import { TiForm } from '../../index.js';
import { isMap, isObject } from 'lodash';
import { transMapValueEnum, transObjectValueEnum } from '../../../utils/transValueEnum.js';
import { TiRadio } from '../../../TiRadio/index.js';

var TiFormRadioGroup = function TiFormRadioGroup(props) {
  var name = props.name,
    label = props.label,
    rules = props.rules,
    border = props.border,
    description = props.description,
    valueEnum = props.valueEnum,
    _a = props.direction,
    direction = _a === void 0 ? 'horizontal' : _a,
    _b = props.fieldProps,
    fieldProps = _b === void 0 ? {} : _b,
    subscribe = props.subscribe;
  var options = useMemo(function () {
    if (isMap(valueEnum)) {
      return transMapValueEnum(valueEnum);
    }
    if (isObject(valueEnum)) {
      return transObjectValueEnum(valueEnum);
    }
  }, [valueEnum]);
  return /*#__PURE__*/React.createElement(TiForm.Item, {
    name: name,
    label: label,
    rules: rules,
    description: description,
    direction: direction,
    border: border,
    subscribe: subscribe
  }, /*#__PURE__*/React.createElement(TiRadio.Group, _extends({
    options: options
  }, fieldProps)));
};

export { TiFormRadioGroup as default };
